module.exports = __webpack_public_path__ + "img/3沙發區.02912bad.jpg";